import { render, staticRenderFns } from "./Verprocedimiento.vue?vue&type=template&id=55b56e5a&scoped=true"
import script from "./Verprocedimiento.vue?vue&type=script&lang=js"
export * from "./Verprocedimiento.vue?vue&type=script&lang=js"
import style0 from "./Verprocedimiento.vue?vue&type=style&index=0&id=55b56e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b56e5a",
  null
  
)

export default component.exports